module.exports = __webpack_public_path__ + "img/snake_box.d444781e.png";